import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import CadastroIrmandade from './CadastroIrmandade';
import EditarIrmandade from './EditarIrmandade';
import IrmandadeTodos from './IrmandadeTodos';

const Irmandade = () => {
  const location = useLocation();

  // Rotas exclusivas de formulário (sem layout de lista)
  if (location.pathname.includes('/cadastro') || location.pathname.includes('/editar')) {
    return (
      <Routes>
        <Route path="/cadastro" element={<CadastroIrmandade />} />
        <Route path="/editar/:id" element={<EditarIrmandade />} />
      </Routes>
    );
  }

  return (
    <Routes>
      {/* Todas as sub-rotas caem na lista unificada */}
      <Route path="/*" element={<IrmandadeTodos />} />
    </Routes>
  );
};

export default Irmandade;
